import ReactDOM from 'react-dom/client'
import {HelmetProvider} from 'react-helmet-async'
import {MathJaxContext} from 'better-react-mathjax'
import {App} from './components/app'
import Instrumentation from './instrumentation'
import Tracking from './tracking'
import {DeployStage, Env} from './env'

if (Env.shared.stageIsAbove(DeployStage.Test)) {
  Instrumentation.shared.initialize()
  Tracking.shared.initialize()
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <HelmetProvider>
    <MathJaxContext>
      <App />
    </MathJaxContext>
  </HelmetProvider>,
)
